<template>
  <div class="overlay-thumbnail-wrapper">
    <div class="overlay-thumbnail"
      @click="$emit('selectRecord', defaultSettings)" 
      :style="style"
      :class="{'selected': isSelected(defaultSettings)}">
      <image-not-found v-if="imgNotFound" />
      <canvas-image :img="img" :canvasSize="fit" :imgSize="fit" />
      <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
      <image-button 
        fab
        :btnClass="'rgb-button' + (showRGB ? ' active' : '')"
        image="rgb-icon.png"
        @click.stop.prevent="toggleShowRGB" />
      <span class="thumb-date">{{image.exDateDisplay}}</span>
    </div>
    <v-expand-transition>
      <div v-show="openRGB">
        <div
          v-for="(setting, index) in colorSettingOptions"
          :key="image.imgKey + index"
          class="overlay-thumbnail"
          :class="{'selected': isSelected(setting), ['border-' + setting.grayscaleMode.toLowerCase()]: true}"
          @click="$emit('selectRecord', setting)"
          :style="style">
          <image-not-found v-if="imgNotFound" />
          <pixel-shaded-canvas
            :img="img"
            :colorSettings="setting"
            :canvasSize="fit"
            :imgSize="fit"
            :dontUseWebgl="true"/>
          <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
          <span class="overlay-thumbnail-caption">
            <background-image :image="setting.icon" />
          </span>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import canvasImage from "../../canvas/components/CanvasImage";
import pixelShadedCanvas from "../../canvas/components/PixelShadedCanvas";
import imageButton from "../controls/ImageButton";
import backgroundImage from "../controls/BackgroundImage";
import imageNotFound from "../misc/ImageNotFound";
import { setFittedSize, defaultSize } from "../../canvas/geometry";
import { GRAYSCALE_MODES } from "../../config/config";
import { defaultColorSettings } from "../../canvas/canvasUtils";
export default {
  name: "overlayThumbnail",
  components: { pixelShadedCanvas, canvasImage, imageButton, backgroundImage, imageNotFound },
  props: [
    "image",
    "colorSettingOptions",
    "colorSettings",
    "selectedImage",
    "size"
  ],
  data() {
    return {
      showRGB: false,
      defaultSettings: defaultColorSettings()
    };
  },
  computed: {
    isLoading() {
      return this.image && (this.image.imgIsLoading || this.image.imgIsQueued);
    },
    imgNotFound() {
      return !!(this.image && this.image.imgNotFound);
    },
    img() {
      return (
        this.image && (this.image.imgHtmlObject)
      );
    },
    style() {
      return { height: this.size && this.size.h + "px" };
    },
    imgSize() {
      return (this.image && this.image.imgSize) || defaultSize();
    },
    fit() {
      let fit = defaultSize();
      setFittedSize(this.size, this.imgSize, fit, 5);
      return fit;
    },
    openRGB(){
      return this.showRGB || (this.image === this.selectedImage  
      && this.colorSettings.grayscaleMode !== GRAYSCALE_MODES.None);
    }
  },
  methods: {
    isSelected(colorSettings) {
      return (
        this.image === this.selectedImage 
        && this.colorSettings.grayscaleMode === colorSettings.grayscaleMode
      );
    },
    toggleShowRGB(){
      this.showRGB = !this.showRGB
      if (!this.showRGB) this.$emit("selectRecord", this.defaultSettings);
    }
  },
  watch: {
    image(){
      this.showRGB = false;
    }
  }
};
</script>